import { createFileRoute, redirect } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { LoginPage } from "@/modules/auth";

export const Route = createFileRoute("/auth/login")({
  component: () => (
    <>
      <DocumentTitle
        title="Login"
        description="Sign in to your LAMPU Seller Center account."
      />
      <LoginPage />
    </>
  ),
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: "/"
      });
    }
  }
});
